<template>
  <div>
    <loading-indicator v-show="isLoading" 
                       :width="loadingIndicatorWidthAndHeight" 
                       :height="loadingIndicatorWidthAndHeight">
    </loading-indicator>
    <a v-if="link" :href="link" :target="linkTarget" v-show="!isLoading">
      <img :class="{'img-fluid': responsive}"
           :src="imageSource(filename)" 
           :alt="filename" 
           :width="imageWidthAttribute" 
           :height="imageHeightAttribute"
           @load="isLoading = false">
      <div v-if="label" class="image-label">{{ label }}</div>
      <div v-if="sizeLabel" class="image-size">{{ sizeLabel }}</div>
    </a>
    <span v-else v-show="!isLoading">
      <img :class="{'img-fluid': responsive}"
           :src="imageSource(filename)" 
           :alt="filename" 
           :width="imageWidthAttribute" 
           :height="imageHeightAttribute"
           @load="isLoading = false">
      <div v-if="label" class="image-label">{{ label }}</div>
      <div v-if="sizeLabel" class="image-size">{{ sizeLabel }}</div>
    </span>
  </div>  
</template>

<script>
  export default {
    props: {
        imageServerBasePath: { type: String, required: true },
        filename: { type: String, require: true },
        label: { type: String, require: false },
        width: { type: Number, required: false, default: null },
        height: { type: Number, required: false, default: null },
        link: { type: String, require: false },
        linkTarget: { type: String, require: false, default: "_self" },
        sizeLabel: { type: String, require: false },
        imageDisplayFormat: { type: String, required: false, default: 'jpg' },
        rotation: { type: Number, required: false, default: 0 },
        scaleFactor: { type: Number, required: false, default: 1.0 },
        modificationTime: { type: Number, require: false },
        responsive: { type: Boolean, require: false, default: false },
    },
    
    data() {
      return {
        defaultWidth: 200,
        isLoading: true
      }
    },

    computed: {
      imageWidthAttribute: function() {
        // use the scale factor to calculate the image width attribute
        if(this.width !== null) {
          return this.width * this.scaleFactor;
        }
        else if(this.width === null && this.height === null) {
          return this.defaultWidth * this.scaleFactor;
        } else {
          return this.width;
        }
      },
      imageHeightAttribute: function() {
        // use the scale factor to calculate the image height attribute
        if(this.height !== null) {
          return this.height * this.scaleFactor;
        } else {
          return this.height;
        }
      },
      loadingIndicatorWidthAndHeight: function() {
        // calculate with of loading indicator dynamically
        var imageSize;
        if(this.width !== null) { // use width if set
          imageSize = this.width;
        } else if(this.height !== null) { // otherwise use height if set
          imageSize = this.height;
        } else {
          imageSize = defaultWidth; // otherwise use default width
        }
        // apply scale factor to loading indicator width/height
        imageSize = imageSize * this.scaleFactor;
        
        // set the loading indicator width and height to one quarter of the image size
        var widthAndHeight = imageSize / 4;
        // set min widthAndHeight to 20
        if(widthAndHeight < 20) {
          widthAndHeight = 20;
        }
        // set max widthAndHeight to 100
        if(widthAndHeight > 100) {
          widthAndHeight = 100;
        }
        return widthAndHeight;
      },
    },

    methods: {
      imageSource: function(image) {
        return this.imageServerBasePath + '/' + this.filename + '/full/' + this.getWidthHeightParameter(this.width, this.height) + '/' + (this.rotation ? this.rotation:  0) + '/default.' + this.imageDisplayFormat + (this.modificationTime ? '?' + this.modificationTime : '');
      },

      getWidthHeightParameter(width, height) {
        var widthHeightParameter;

        // default width to defaultWidth and use width if neither width nor height are passed in
        if(width == null && height == null) { 
          widthHeightParameter = this.defaultWidth + ',';
        }

        // in only width is passed in, use width
        if(width !== null && height === null) { 
          widthHeightParameter = width + ',';
        }
  
        // in only height is passed in, use height
        if(width === null && height !== null) { 
          widthHeightParameter = ',' + height; 
        }

        // in both width and height are pased in, use both
        if(width !== null && height !== null) { 
          widthHeightParameter =  width + ',' + height; 
        }
        return widthHeightParameter;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .image-label, .image-size {
    color: #111;
    font-size: 0.875rem;
  }
  figure img {
    padding:.125rem !important;
    max-width: 100%;
    max-height: 10rem !important;
    width: auto;
    height: auto;
  }
</style>